import React from "react";
import styles from "./_WorkflowTarefaDataInclusao.less";
import PropTypes from "prop-types";
import useFormatter from "../../../hooks/useFormatter";
import { ClockCircleOutlined } from "@ant-design/icons";
import WorkflowTarefaInfoTag from "../_WorkflowTarefaInfoTag";

export default function WorkflowTarefaDataInclusao(props) {
  const { dataInclusao } = props;
  const { formatDate } = useFormatter();

  let className = styles["workflow-tarefa-data-inclusao"];
  className += " " + styles["read-only"];
  if (!dataInclusao) className += " " + styles["nao-preenchido"];

  if (dataInclusao)
    return (
      <div className={className}>
        <div>
          <WorkflowTarefaInfoTag icon={<ClockCircleOutlined />} text={formatDate(dataInclusao)} />
        </div>
      </div>
    );

  return <div className={className}>(não preenchido)</div>;
}

WorkflowTarefaDataInclusao.propTypes = {
  dataInclusao: PropTypes.string,
};
